    import React, { useState } from "react";

    const fieldOptions = [
      "History",
      "Transport",
      "Social Impact",
      "Population",
      "Culture",
      "Economy",
      "Technology",
      "Infrastructure",
      "Public"
    ];

    const AddFieldModal = ({ isOpen, onClose, onAddFields }) => {
      const [selectedFields, setSelectedFields] = useState([]);
      const [error, setError] = useState("");

      if (!isOpen) return null;

      const handleCheckboxChange = (field) => {
        setError("");
        if (selectedFields.includes(field)) {
          setSelectedFields(selectedFields.filter((f) => f !== field));
        } else {
          setSelectedFields([...selectedFields, field]);
        }
      };

      const handleSubmit = () => {
        if (selectedFields.length === 0) {
          setError("Please select at least one field");
          return;
        }
        onAddFields(selectedFields);
        setSelectedFields([]);
        onClose();
      };

      return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 backdrop-blur-sm">
          <div className="bg-gray-800 rounded-xl p-6 w-full max-w-md shadow-2xl border border-gray-700">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-white">Add New Fields</h2>
              <button 
                onClick={onClose}
                className="text-gray-400 hover:text-white transition-colors"
              >
                ✕
              </button>
            </div>
            
            {error && (
              <div className="mb-4 p-2 bg-red-900 text-red-100 rounded-md text-sm">
                {error}
              </div>
            )}

            <div className="space-y-3 mb-6 max-h-96 overflow-y-auto pr-2">
              {fieldOptions.map((field) => (
                <div 
                  key={field} 
                  className={`flex items-center p-3 rounded-lg cursor-pointer transition-colors ${selectedFields.includes(field) ? 'bg-blue-900 border border-blue-700' : 'hover:bg-gray-700'}`}
                  onClick={() => handleCheckboxChange(field)}
                >
                  <div className={`h-5 w-5 rounded flex items-center justify-center mr-3 ${selectedFields.includes(field) ? 'bg-blue-500' : 'border border-gray-500'}`}>
                    {selectedFields.includes(field) && "✓"}
                  </div>
                  <span className="text-gray-100 font-medium">{field}</span>
                </div>
              ))}
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={onClose}
                className="px-5 py-2 rounded-lg border border-gray-600 text-gray-300 hover:bg-gray-700 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors font-medium shadow-md"
              >
                Add Fields
              </button>
            </div>
          </div>
        </div>
      );
    };

    export default AddFieldModal;